
import { ComponentRef, Directive, ElementRef, Input, OnInit, Renderer2, ViewContainerRef, HostBinding, inject, input } from '@angular/core';

import { SpinnerComponent } from './spinner.component';

@Directive({ selector: '[appSpinner]' })
export class SpinnerDirective implements OnInit {
  private directiveView = inject(ViewContainerRef);
  private renderer = inject(Renderer2);
  private directiveElement = inject(ElementRef);


  spinner: ComponentRef<SpinnerComponent>;

  @HostBinding('class.spinner-container') isSpinnerExist = false;

  /**
   * Spinner message shown next to the icon
   */
  readonly spinnerMessage = input<string>(undefined);

  /**
   * Spinner status color active, disabled, primary, info, success, warning, danger
   */
  readonly spinnerStatus = input<string>(undefined);

  /**
   * Spinner size, available sizes: xxsmall, xsmall, small, medium, large, xlarge, xxlarge
   */
  readonly spinnerSize = input<string>(undefined);

  /**
   * Directive value - show or hide spinner
   */
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('appSpinner')
  set appSpinner(val: boolean) {
    if (this.spinner) {
      if (val) {
        this.show();
      } else {
        this.hide();
      }
    } else {
      this.shouldShow = val;
      if (this.shouldShow) {
        this.show();
      }
    }
  }

  private shouldShow = false;

  ngOnInit() {
    if (this.shouldShow) {
      this.show();
    }
  }

  hide() {
    if (this.isSpinnerExist) {
      this.directiveView.remove();
      this.isSpinnerExist = false;
    }
  }

  show() {
    if (!this.isSpinnerExist) {
      this.spinner = this.directiveView.createComponent(SpinnerComponent);
      this.setInstanceInputs(this.spinner.instance);
      this.spinner.changeDetectorRef.detectChanges();
      this.renderer.appendChild(this.directiveElement.nativeElement, this.spinner.location.nativeElement);
      this.isSpinnerExist = true;
    }
  }

  setInstanceInputs(instance: SpinnerComponent) {
    const spinnerMessage = this.spinnerMessage();
    if (typeof spinnerMessage !== 'undefined') {
      instance.message = spinnerMessage;
    }
    const spinnerStatus = this.spinnerStatus();
    if (typeof spinnerStatus !== 'undefined') {
      instance.status = spinnerStatus;
    }
    const spinnerSize = this.spinnerSize();
    if (typeof spinnerSize !== 'undefined') {
      instance.size = spinnerSize;
    }
  }
}
